import { render, staticRenderFns } from "./KycInfoContainer.vue?vue&type=template&id=5cb84bac&"
import script from "./KycInfoContainer.vue?vue&type=script&lang=js&"
export * from "./KycInfoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports